import { timeModel } from '~/models';
export function mapOverviewItemToRow(item, texts) {
    const display = resolveDisplay(item, texts);
    if (display == null) return null;
    const refs = resolveRefs(item);
    return {
        id: item.id,
        title: item.title,
        status: item.status,
        badgeLabel: display.badgeLabel,
        badgeSkin: display.badgeSkin,
        secondaryLine: display.secondaryLine,
        relationshipId: refs.relationshipId,
        draftId: refs.draftId,
        progressStatus: refs.progressStatus
    };
}
function resolveRefs(item) {
    switch(item.status){
        case 'active':
            var _item_active, _item_active1;
            return {
                relationshipId: blankToNull((_item_active = item.active) === null || _item_active === void 0 ? void 0 : _item_active.relationshipId),
                draftId: blankToNull((_item_active1 = item.active) === null || _item_active1 === void 0 ? void 0 : _item_active1.draftId),
                progressStatus: null
            };
        case 'paymentConnected':
            return refsWithProgress(item.paymentConnected);
        case 'reviewed':
            return refsWithProgress(item.reviewed);
        case 'sent':
            return refsWithProgress(item.sent);
        case 'scheduled':
            var _item_scheduled, _item_scheduled1;
            return {
                relationshipId: blankToNull((_item_scheduled = item.scheduled) === null || _item_scheduled === void 0 ? void 0 : _item_scheduled.relationshipId),
                draftId: blankToNull((_item_scheduled1 = item.scheduled) === null || _item_scheduled1 === void 0 ? void 0 : _item_scheduled1.draftId),
                progressStatus: null
            };
        case 'draft':
            var _item_draft, _item_draft1;
            return {
                relationshipId: blankToNull((_item_draft = item.draft) === null || _item_draft === void 0 ? void 0 : _item_draft.relationshipId),
                draftId: blankToNull((_item_draft1 = item.draft) === null || _item_draft1 === void 0 ? void 0 : _item_draft1.draftId),
                progressStatus: null
            };
        default:
            return {
                relationshipId: null,
                draftId: null,
                progressStatus: null
            };
    }
}
function refsWithProgress(variant) {
    var _ref;
    return {
        relationshipId: blankToNull(variant === null || variant === void 0 ? void 0 : variant.relationshipId),
        draftId: blankToNull(variant === null || variant === void 0 ? void 0 : variant.draftId),
        progressStatus: (_ref = variant === null || variant === void 0 ? void 0 : variant.progressStatus) !== null && _ref !== void 0 ? _ref : null
    };
}
function blankToNull(value) {
    return value == null || value === '' ? null : value;
}
function resolveDisplay(item, texts) {
    const { badge, secondary } = texts;
    switch(item.status){
        case 'active':
            if (item.active == null) return null;
            return {
                badgeLabel: badge.active(),
                badgeSkin: 'success',
                secondaryLine: secondary.active({
                    date: timeModel.formatDateLong(item.active.effectiveDate)
                })
            };
        case 'paymentConnected':
            if (item.paymentConnected == null) return null;
            return {
                badgeLabel: badge.paymentConnected(),
                badgeSkin: 'default',
                secondaryLine: secondary.paymentConnected({
                    date: timeModel.formatDateLong(item.paymentConnected.at)
                })
            };
        case 'reviewed':
            if (item.reviewed == null) return null;
            return {
                badgeLabel: badge.reviewed(),
                badgeSkin: 'default',
                secondaryLine: secondary.reviewed({
                    date: timeModel.formatDateLong(item.reviewed.at)
                })
            };
        case 'sent':
            if (item.sent == null) return null;
            return {
                badgeLabel: badge.sent(),
                badgeSkin: 'default',
                secondaryLine: resolveSentLine(item.sent, secondary)
            };
        case 'scheduled':
            if (item.scheduled == null) return null;
            return {
                badgeLabel: badge.scheduled(),
                badgeSkin: 'default',
                secondaryLine: secondary.scheduled({
                    date: timeModel.formatDateLong(item.scheduled.at)
                })
            };
        case 'draft':
            if (item.draft == null) return null;
            return {
                badgeLabel: badge.draft(),
                badgeSkin: 'default',
                secondaryLine: secondary.draft({
                    name: item.draft.lastModifiedBy || secondary.unknownUser(),
                    date: timeModel.formatDateLong(item.draft.lastModifiedAt)
                })
            };
        default:
            return null;
    }
}
function resolveSentLine(sent, secondary) {
    if (sent.expiresAt == null) {
        return secondary.sent({
            date: timeModel.formatDateLong(sent.sentAt)
        });
    }
    return secondary.sentWithExpiry({
        sentDate: timeModel.formatDateLong(sent.sentAt),
        expiresDate: timeModel.formatDateLong(sent.expiresAt)
    });
}
